export const DEFAULT_ACTION_PREFIX = 'KARNOTT_AUTHENTICATION';
export const DEFAULT_SERVICE_NAME = 'authentication';
export const DEFAULT_ACCESSOR_CHAIN = [DEFAULT_SERVICE_NAME];
export const DEFAULT_HEADER_KEY = 'Authorization';
export const DEFAULT_TOKEN_TYPE = 'Bearer';
